<template>
  <div class="section-container">
    <div class="section-main-container">
      <div class="core-content">
        <div class="left-container">
          <SpringText class="title-text" text="Character Development" />
          <fadeInAnimation>
            <swiper class="thumbs-swiper" ref="swiperThumbsRef" :options="swiperThumbsOptions">
              <swiper-slide class="slide-content" v-for="(item, index) in coreList" :key="item.id">
                <ThumbsItem :info="item" />
              </swiper-slide>
            </swiper>
          </fadeInAnimation>
        </div>
        <div class="right-container">
          <div class="swiper-outer">
            <svg-icon icon-class="howToPlay_core_border" class-name="border-svg" />
            <div class="swiper-padding">
              <swiper class="core-swiper" ref="swiperMainRef" :options="swiperOptions">
                <swiper-slide class="slide-content" v-for="(item, index) in coreList" :key="item.id">
                  <SwiperItem :info="item" />
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import coreJson from "./json/index.json";
import SwiperItem from "./components/swiperItem";
import ThumbsItem from "./components/thumbsItem";
import SpringText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";
import "swiper/css/swiper.css";
import responsiveMixin from "@/mixins/responsive";

let vm;
export default {
  mixins: [responsiveMixin],
  components: { SwiperItem, ThumbsItem, SpringText, fadeInAnimation },
  data() {
    return {
      coreList: coreJson,
      swiperOptions: {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        // autoplay: false,
        loop: false,
        slidesPerView: 1,
        on: {
          resize: function () {
            this.update();
          },
        },
        thumbs: {
          swiper: {
            el: ".thumbs-swiper",
            direction: 'vertical',
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            freeMode: true,
            autoplay: false,
            loop: false,
            slidesPerView: 3,
            spaceBetween: 20,
            watchSlidesVisibility: true,
            watchSlidesProgress: true
          }
        }
      },
      swiperThumbsOptions: {
        direction: 'vertical',
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        freeMode: true,
        autoplay: false,
        loop: false,
        slidesPerView: 3,
        spaceBetween: 20,
        watchSlidesVisibility: true,
        watchSlidesProgress: true
      },
    };
  },
  computed: {},
  watch: {},
  beforeDestroy() { },
  created() {
    vm = this;
  },
  mounted() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>